<ng-content></ng-content>
<i data-testid="SUBSYS2_LIST_HEADER_ORDER_NONE" class="material-icons" *ngIf="direction === ''">swap_vert</i>
<i data-testid="SUBSYS2_LIST_HEADER_ORDER_ASC" class="material-icons"
	*ngIf="direction === 'asc'">keyboard_arrow_down</i>
<i data-testid="SUBSYS2_LIST_HEADER_ORDER_DESC" class="material-icons"
	*ngIf="direction === 'desc'">keyboard_arrow_up</i>